import { BKJButton, BKJTextInput, Flex } from '@bookjane2/bookjane-design-library';
import { ChangeFunctionType } from '@bookjane2/bookjane-design-library/lib/common.types';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { useFetchCommunitiesDataContext } from 'modals/CustomFieldModal/Contexts/FetchCommunities.data.context';
import { useFetchCommunitiesCountDataContext } from 'modals/CustomFieldModal/Contexts/FetchCommunitiesCount.data.context';
import {
  CUSTOM_FIELDS_MODAL_FACILITIES_EMPTY_SEARCH,
  SEARCH_FACILITY_INITIAL_STATE,
} from 'modals/CustomFieldModal/CustomFieldModal.constants';
import { FacilitiesSelectionTable } from 'modals/CustomFieldModal/Views/ApplyEditFacilitiesToCustomField/FacilitiesSelectionTable';
import {
  FacilitiesSelectionCountLabel,
  Heading,
  NoResultsFoundWrapper,
} from 'modals/CustomFieldModal/CustomFieldModal.styled';
import { FC, Fragment, MouseEventHandler } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { useApplyFacilitiesFormContext } from 'modals/CustomFieldEditModal/contexts/ApplyFacilities.form.context';

export const EditFacilitiesView: FC = () => {
  const {
    data: fetchCommunities,
    values: fetchCommunitiesValues,
    onChange,
    isLoading,
  } = useFetchCommunitiesDataContext();
  const fetchCommunitiesCount = useFetchCommunitiesCountDataContext();
  const {
    values,
    handleApplyAllFacilitiesChange,
    handleApplyFacilitiesChange,
    isDisabled,
    onSubmit,
  } = useApplyFacilitiesFormContext();
  const { t } = useTranslation();

  return (
    <Fragment>
      <Flex flexDirection="column" gap="32px" padding="32px" flex="1">
        <Heading>{t('settings:SELECT_LOCATIONS_TO_APPLY')}:</Heading>
        <BKJTextInput
          onChange={onChange as ChangeFunctionType}
          name="byName"
          value={fetchCommunitiesValues?.byName}
          leftIconProps={{ iconName: 'Search' }}
          placeholder={t('settings:SEARCH_LOCATION')}
          rightIconProps={
            fetchCommunitiesValues?.byName === '' ? undefined : { iconName: 'CloseBold' }
          }
          onClick={() => onChange(SEARCH_FACILITY_INITIAL_STATE)}
        />
      </Flex>
      {!!fetchCommunities?.fetchCommunities.nodes?.length || isLoading ? (
        <FacilitiesSelectionTable
          values={values}
          handleApplyAllFacilitiesChange={handleApplyAllFacilitiesChange}
          handleApplyFacilitiesChange={handleApplyFacilitiesChange}
        />
      ) : (
        <NoResultsFoundWrapper alignItems="center" justifyContent="center">
          {t(CUSTOM_FIELDS_MODAL_FACILITIES_EMPTY_SEARCH)}
        </NoResultsFoundWrapper>
      )}
      <BKJSideModalFooter justifyContent="space-between">
        <FacilitiesSelectionCountLabel>
          {`${t('common:SELECTED')}: ${values.communityIds.length}/${fetchCommunitiesCount}`}
        </FacilitiesSelectionCountLabel>
        <BKJButton
          variant="PurpleSolid"
          width="180px"
          disabled={isDisabled}
          onClick={onSubmit as unknown as MouseEventHandler<HTMLButtonElement>}
        >
          {t('auth:APPLY')}
        </BKJButton>
      </BKJSideModalFooter>
    </Fragment>
  );
};
